import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedEventStatus: cacheLs.get_event_status()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
